import { Advertisement } from "@cryptors/api-client";
import { Typography, Stack } from "@mui/material";
import { useShow, IResourceComponentsProps } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";

export const AdvertisementShow: React.FC<IResourceComponentsProps> = () => {
  const { query } = useShow();
  const { data, isLoading } = query;

  const record = data?.data as Advertisement;

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          Titre
        </Typography>
        <TextField value={record?.title ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Url
        </Typography>
        <TextField value={record?.url ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Image
        </Typography>
        <img src={record?.image?.url} alt="Cryptor" width="100" />
        <Typography variant="body2" color="text.secondary">
          Les cryptors associés à cette publicité se gèrent depuis la fiche du
          cryptor.
        </Typography>
      </Stack>
    </Show>
  );
};
